import React, { useState, useEffect } from 'react';
import Header from './components/Header.js';
import Classes from './components/Classes.js';
import Pictures from './components/Pictures.js';
import Gallery from './components/Gallery.js';
import About from './components/About.js';
import Pricing from './components/Pricing.js';
import Timings from './components/Timings.js';
import Testimonials from './components/Testimonials.js';
import Contact from './components/Contact.js';
import Footer from './components/Footer.js';
import ScrollToTop from './components/ScrollToTop.js';
import ParticleBackground from './components/ParticleBackground.js';
import Analytics from './components/Analytics.js'; // Import Google Analytics component
import IMAGES from './assets/index.js'; // Import our centralized images

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    
    return () => clearTimeout(timer);
  }, []);

  // Add event listener for Bootstrap carousel to ensure proper spacing after transitions
  useEffect(() => {
    if (!loading) {
      const adjustCarouselHeight = () => {
        const carouselItems = document.querySelectorAll('.carousel-item');
        carouselItems.forEach(item => {
          const yogaBox = item.querySelector('.yoga_box');
          const yogaImg = item.querySelector('.yo_img');
          
          if (yogaBox && yogaImg) {
            yogaBox.style.marginTop = '0';
            yogaImg.style.marginBottom = '20px';
          }
        });
      };
      
      // Call on initial load and whenever carousel slides
      adjustCarouselHeight();
      
      const carouselElement = document.getElementById('myCarousel');
      if (carouselElement) {
        carouselElement.addEventListener('slid.bs.carousel', adjustCarouselHeight);
      }
      
      return () => {
        if (carouselElement) {
          carouselElement.removeEventListener('slid.bs.carousel', adjustCarouselHeight);
        }
      };
    }
  }, [loading]);

  return (
    <>
      {/* Add Google Analytics component */}
      <Analytics />
      
      {/* Add particle background before anything else and ensure it's always displayed */}
      {!loading && <ParticleBackground />}
      
      <div className="main-layout" style={{ position: 'relative', backgroundColor: 'transparent' }}>
        {loading ? (
          <div className="loader_bg">
            <div className="loader">
              <img src={IMAGES.loader} alt="Loading..." />
            </div>
          </div>
        ) : (
          <>
            <div>
              <Header />
            </div>
            <div className="container-fluid">
              <Classes />
              <Pictures />
              <Gallery />
              <About />
              <Pricing />
              <Timings />
              <Testimonials />
              <Contact />
            </div>
            <Footer />
            <ScrollToTop />
          </>
        )}
      </div>
    </>
  );
}

export default App;
